<script lang="ts">
	import { booleanDisplayValue } from "#lib/boolean.js";
	import BooleanSelector from "#lib/components/BooleanSelector.svelte";
	import type { DataTypeInputProps, DataTypeInputValue } from "#lib/components/flow/editor/data-types/inputs/dataTypeInput.js";

	let { value = $bindable(), defaultValue, disabled, invalid, onchange }: DataTypeInputProps = $props();

	const displayValue = $derived(booleanDisplayValue(value !== undefined && typeof value === "boolean" ? value : undefined));
	const placeholder = $derived(booleanDisplayValue(defaultValue !== undefined && typeof defaultValue === "boolean" ? defaultValue : undefined));

	function handleSelect(selected: boolean, event: Event) {
		value = selected;
		const next: CustomEvent<DataTypeInputValue> = new CustomEvent(event.type, { detail: value ?? null });
		onchange?.(next);
	}
</script>

<BooleanSelector {displayValue} {placeholder} onSelect={handleSelect} {disabled} {invalid} dataActionName="data-property-bool" />
